import * as v from 'valibot';

const shipmentTransportDetailsApiSchema = v.object({
  appointmentType: v.nullable(v.string()),
  carrierActualDeliveryDate: v.nullable(v.string()),
  carrierActualDeliveryDateEST: v.nullable(v.string()),
  carrierActualShipDate: v.nullable(v.string()),
  carrierActualShipDateEST: v.nullable(v.string()),
  carrierAppointmentDeliveryDate: v.nullable(v.string()),
  carrierAppointmentDeliveryDateEST: v.nullable(v.string()),
  carrierAppointmentShipDate: v.nullable(v.string()),
  carrierAppointmentShipDateEST: v.nullable(v.string()),
  contactEmail: v.nullable(v.string()),
  contactName: v.nullable(v.string()),
  dockNumber: v.nullable(v.string()),
  doorDockID: v.nullable(v.string()),
  extension: v.nullable(v.string()),
  fromDays: v.nullable(v.number()),
  fromTime: v.nullable(v.string()),
  isPhoneFormatRemoveValidation: v.nullable(v.number()),
  isResetNew: v.number(),
  itemID: v.number(),
  legMiles: v.number(),
  oldStopSequence: v.number(),
  phone: v.nullable(v.string()),
  pickupDeliveryID: v.nullable(v.string()),
  sequence: v.number(),
  shipperRequestedDeliveryDate: v.nullable(v.string()),
  shipperRequestedDeliveryDateEST: v.nullable(v.string()),
  shipperRequestedShipDate: v.nullable(v.string()),
  shipperRequestedShipDateEST: v.nullable(v.string()),
  shipRecContactNameColumnSize: v.number(),
  shipRecEmailColumnSize: v.number(),
  subItemID: v.number(),
  taxId: v.nullable(v.string()),
  toDays: v.nullable(v.number()),
  toTime: v.nullable(v.string()),
  uom: v.nullable(v.string()),
});

const shipmentDefaultAddressApiSchema = v.object({
  address: v.string(),
  address1: v.nullable(v.string()),
  city: v.string(),
  countryCode: v.string(),
  countryName: v.string(),
  details: v.nullable(v.string()),
  gridOperation: v.number(),
  isResetNew: v.number(),
  itemID: v.number(),
  locationID: v.string(),
  name: v.string(),
  oldStopSequence: v.number(),
  port: v.string(),
  portRecKey: v.nullable(v.string()),
  portType: v.string(),
  postalCode: v.string(),
  shipmentNumber: v.nullable(v.string()),
  shipmentTransportDetails: shipmentTransportDetailsApiSchema,
  shipRecKey: v.string(),
  state: v.string(),
  stateName: v.string(),
  stop: v.nullable(v.string()),
  stopID: v.nullable(v.string()),
  stopSequence: v.number(),
  stopType: v.string(),
  stopTypeID: v.string(),
});

export const shipmentDefaultAddressListApiSchema = v.array(shipmentDefaultAddressApiSchema);

export type ShipmentDefaultAddressApi = v.InferOutput<typeof shipmentDefaultAddressListApiSchema>;
